.buttonContainer {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    margin-top: 24px;
}

.formFieldsColumn {
    display: flex;
    flex-direction: column;
    gap: 24px;
}